import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Input, Select, Typography } from 'antd';
import { Locale } from '../../../context/AppProvider';
import styles from './UsersContainer.module.scss';

const { Search } = Input;

interface UserFilterProps {
  setFilteredRole(type: string): void;
  setIsModalVisible(isModalVisible: boolean): void;
  setSearchValue(value: string): void;
}

const UserFilters: React.FC<UserFilterProps> = ({
  setFilteredRole,
  setIsModalVisible,
  setSearchValue,
}) => {
  const { messages } = React.useContext(Locale);

  const onSearch = (e) => {
    setSearchValue(e.target.value);
  };
  return (
    <div className={`${styles.sharedContainer} ${styles.filtersContainer}`}>
      <div className={styles.searchItem}>
        <Typography.Text className={styles.filterLabel}>
          {messages['users.filters.search.label']}
        </Typography.Text>
        <Search
          placeholder={messages['users.filters.search.placeholder']}
          onChange={onSearch}
          data-testid={'search-user-bar'}
        />
      </div>
      <div className={styles.filterItem}>
        <Typography.Text className={styles.filterLabel}>
          {messages['users.filters.role.label']}
        </Typography.Text>
        <Select
          onChange={(value) => setFilteredRole(value)}
          options={[
            {
              label: messages['users.filters.role.options.all'],
              value: '',
            },
            {
              label: messages['users.filters.role.options.assignee'],
              value: messages['users.filters.role.options.assignee'],
            },
            {
              label: messages['users.filters.role.options.manager'],
              value: messages['users.filters.role.options.manager'],
            },
          ]}
          data-testid={'search-user-dropdown'}
        />
      </div>
      <div className={styles.buttonItem}>
        <Button
          className={styles.sortButton}
          type="primary"
          onClick={() => {
            setIsModalVisible(true);
          }}
          data-testid={'add-user-btn'}
        >
          <PlusOutlined />
          {messages['users.filters.buttons.add']}
        </Button>
      </div>
    </div>
  );
};

export default UserFilters;
